export enum OwnershipTransferPrivateSellerStep {
  SelectServiceType = 'SelectServiceType',
  SelectStationaryLineType = 'SelectStationaryLineType',
  SelectCellularNumber = 'SelectCellularNumber',
  GeneralMessage = 'GeneralMessage',
  BuyerDetails = 'BuyerDetails',
  BlockingDualNumber = 'BlockingDualNumber',
}

export enum ServiceType {
  Cellular = 'Cellular',
  StationaryLine = 'StationaryLine',
}

export enum ProductType {
  Cellular = 'Cellular',
  TV = 'TV',
  Internet = 'Internet',
  Mapa = 'Mapa',
  Bundle = 'Bundle',
  Unknown = 'Unknown',
}

const brandNameHe = () => window.Config?.brand_Name_HE ?? '';
export const MessageContent = {
  GeneralError: {
    icon: require('../Icons/error.svg'),
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    secondTitle: 'באפשרותך לנסות שוב או לפנות לשירות לקוחות',
    contactUs: true,
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'generalError',
  },
  QuattroServiceError: {
    icon: require('../Icons/error.svg'),
    title: 'לא ניתן לבצע העברת בעלות לשירותי אינטרנט או  TV <br /> בחבילה משולבת',
    secondTitle: 'נשמח לסייע לך',
    contactUs: true,
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
  },
  SuccessPageStationary: {
    icon: require('../Icons/success.svg'),
    title: 'הבקשה להעברת בעלות על שירות  {serviceToTransfer.packageName} נשלחה בהצלחה!',
    secondTitle: 'ברגעים אלו נשלחת הודעה לבעלים העתידי של המספר לשם השלמת התהליך. עם סיום העברת הבעלות, יישלח אליך עדכון ב-SMS',
    contactUs: false,
    borderedMessage: true,
    buttonText: 'להעברת שירות נוסף ',
    buttonClick: 'addAnotherRequest',
    secondButtonText: 'לאזור האישי',
    secondButtonClick: 'privateLobby',
    report: 'successPage',
  },
  SuccessPageCellular: {
    icon: require('../Icons/success.svg'),
    title: 'הבקשה להעברת בעלות על מספר {serviceToTransfer.subscriberNumber} נשלחה בהצלחה!',
    secondTitle: 'ברגעים אלו נשלחת הודעה לבעלים העתידי של המספר לשם השלמת התהליך. עם סיום העברת הבעלות, יישלח אליך עדכון ב-SMS',
    contactUs: false,
    borderedMessage: true,
    buttonText: 'להעברת קו נוסף',
    buttonClick: 'addAnotherRequest',
    secondButtonText: 'לאזור האישי',
    secondButtonClick: 'privateLobby',
    report: 'successPage',
  },
  TechnicianVisitError: {
    icon: require('../Icons/error.svg'),
    title: 'זיהינו שיש קריאת שירות פתוחה על החשבון שלכם',
    secondTitle: 'לא ניתן לבצע העברת בעלות כאשר יש ביקור טכנאי עתידי',
    contactUs: false,
    linkText: 'לביטול ביקור טכנאי באתר',
    linkAction: 'cancelTechnicianVisit',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'technicianVisitError',
  },
  MustVisitServiceCenter: {
    icon: require('../Icons/error.svg'),
    title:
      'לטובת ביצוע העברת בעלות על שירות {serviceToTransfer.packageName} ל{buyerPersonalData.firstName} {buyerPersonalData.lastName}, יש להגיע לאחד ממרכזי השירות',
    contactUs: false,
    linkText: 'מרכזי השירות שלנו',
    linkAction: 'goToServiceCenterPage',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'mustVisitServiceCenter',
  },
  MustVisitServiceCenterCellular: {
    icon: require('../Icons/error.svg'),
    title:
      'לטובת ביצוע העברת בעלות על קו {serviceToTransfer.subscriberNumber} ל{buyerPersonalData.firstName} {buyerPersonalData.lastName} , יש להגיע לאחד ממרכזי השירות',
    contactUs: false,
    linkText: 'מרכזי השירות שלנו',
    linkAction: 'goToServiceCenterPage',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'mustVisitServiceCenter',
  },
  AdditionalOwnersError: {
    icon: require('../Icons/error.svg'),
    title: 'לשירות {serviceToTransfer.packageName} יש יותר מבעלים אחד, לכן לא ניתן לבצע העברת בעלות באתר',
    secondTitle: 'שנחזור אליכם להשלמת התהליך?',
    contactUs: false,
    buttonText: 'שנציג יחזור אלי',
    buttonClick: 'createWorkOrder',
    secondButtonText: 'חזרה לאזור האישי',
    secondButtonClick: 'privateLobby',
    report: 'additionalOwnersError',
  },
  CellularAdditionalOwnersError: {
    icon: require('../Icons/error.svg'),
    title: 'לקו מספר {serviceToTransfer.subscriberNumber} יש יותר מבעלים אחד, לכן לא ניתן לבצע העברת בעלות באתר',
    secondTitle: 'שנחזור אליכם להשלמת התהליך?',
    contactUs: false,
    buttonText: 'שנציג יחזור אלי',
    buttonClick: 'createWorkOrder',
    secondButtonText: 'חזרה לאזור האישי',
    secondButtonClick: 'privateLobby',
    report: 'additionalOwnersError',
  },
  DebtAndPaymentUpdateError: {
    icon: require('../Icons/creditCard.svg'),
    title: 'מצטערים, לא ניתן להשלים את הפעולה!',
    get secondTitle() {
      return `לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך ב${brandNameHe()} ולשלם את החוב.`;
    },
    contactUs: false,
    linkText: 'לתשלום חוב',
    linkAction: 'goToDebtPayment',
    secondLinkText: 'לעדכון אמצעי תשלום',
    secondLinkAction: 'goToUpdatePaymentPage',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'debtAndPaymentUpdateError',
  },
  DebtError: {
    icon: require('../Icons/creditCard.svg'),
    title: 'מצטערים, לא ניתן להשלים את הפעולה!',
    secondTitle: 'לפני שנמשיך בתהליך, עליך לשלם את החוב.',
    contactUs: false,
    linkText: 'לתשלום חוב',
    linkAction: 'goToDebtPayment',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'debtError',
  },
  PaymentUpdateError: {
    icon: require('../Icons/creditCard.svg'),
    title: 'מצטערים, לא ניתן להשלים את הפעולה!',
    get secondTitle() {
      return `לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך ב${brandNameHe()}.`;
    },
    contactUs: false,
    linkText: 'לעדכון אמצעי תשלום',
    linkAction: 'goToUpdatePaymentPage',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'paymentUpdateError',
  },
  FutureAbroadError: {
    icon: require('../Icons/error.svg'),
    title: `קיימת חבילת חו"ל עתידית`,
    secondTitle: 'לצורך השלמת הפעולה באתר יש להסיר את החבילה באיזור האישי ולחזור לתהליך.',
    contactUs: false,
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'futureAbroadError',
  },
  CallbackRequestReceived: {
    icon: require('../Icons/like.svg'),
    title: 'קיבלנו את הפנייה, נציג יחזור אליך בהתאם לשעות פעילות המוקד',
    secondButtonText: 'חזרה לאזור האישי',
    secondButtonClick: 'privateLobby',
    report: '',
  },
};

export const PopupMessageContent = {
  OpenWorkOrder: {
    title: 'לשירות {serviceToTransfer.packageName} קיים תהליך שירות בטיפול',
    secondTitle: 'שנחזור אליכם להשלמת התהליך?',
    buttonText: 'שנציג יחזור אלי',
    buttonClick: 'createWorkOrder',
    secondButtonText: 'חזרה',
    secondButtonClick: 'closePopup',
    report: 'openWorkOrder',
  },
  CellularOpenWorkOrder: {
    title: 'למנוי {serviceToTransfer.subscriberNumber} קיים תהליך שירות בטיפול',
    secondTitle: 'שנחזור אליכם להשלמת התהליך?',
    buttonText: 'שנציג יחזור אלי',
    buttonClick: 'createWorkOrder',
    secondButtonText: 'חזרה',
    secondButtonClick: 'closePopup',
    report: 'openWorkOrder',
  },
  TransferGeneralError: {
    title: 'לא ניתן לבצע העברת בעלות באתר לשירות {serviceToTransfer.packageName}',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'transferGeneralError',
  },
  CellularGeneralTransferError: {
    title: 'לא ניתן לבצע העברת בעלות באתר למנוי {serviceToTransfer.subscriberNumber}',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'transferGeneralError',
  },

  CellularNPStatusError: {
    title: 'מנוי מספר {serviceToTransfer.subscriberNumber}<br /> נמצא בתהליך ניוד',
    secondTitle: `לא ניתן להשלים את העברת הבעלות בזמן תהליך ניוד`,
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'errorNPStatus',
  },
  CellularAbroadError: {
    title: `מנוי מספר {serviceToTransfer.subscriberNumber}<br /> נמצא בחו''ל`,
    secondTitle: 'אפשר להשלים את העברת הבעלות באתר עם חזרת המנוי לארץ',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'errorAbroad',
  },
  CellularEsimError: {
    title: 'מנוי מספר {serviceToTransfer.subscriberNumber}<br /> הינו מנוי eSIM',
    secondTitle: 'בשלב זה לא ניתן להעביר בעלות למנוי eSIM',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'errorEsim',
  },
  CellularSubStatusError: {
    title: 'מנוי מספר {serviceToTransfer.subscriberNumber} מושהה',
    secondTitle: 'שנחזור אליכם להשלמת התהליך?',
    buttonText: 'שנציג יחזור אלי',
    buttonClick: 'createWorkOrder',
    secondButtonText: 'חזרה',
    secondButtonClick: 'closePopup',
    report: 'errorSubStatus',
  },
  CellularDataPackageError: {
    title: 'מנוי מספר {serviceToTransfer.subscriberNumber}<br /> הינו מנוי דאטה',
    secondTitle: 'בשלב זה לא ניתן להעביר בעלות למנוי דאטה',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'errorDataPackage',
  },
  CellularFrozenSubscriptionError: {
    //??? to do
    title: 'מנוי מספר {serviceToTransfer.subscriberNumber}<br /> הינו מנוי בהקפאה',
    secondTitle: 'לא ניתן לבצע העברת בעלות על מנוי בהקפאה',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: '',
  },
  CellularCellcomDuError: {
    title: '<br />זיהינו שיש למנוי מספר {serviceToTransfer.subscriberNumber} שירות נוסף',
    secondTitle: 'שנחזור אליכם להשלמת התהליך?',
    buttonText: 'שנציג יחזור אלי',
    buttonClick: 'createWorkOrder',
    secondButtonText: 'חזרה',
    secondButtonClick: 'closePopup',
    report: 'errorCellcomDu',
  },
  EnergyBundleError: {
    title: 'יש לך חבילה משולבת עם חשמל',
    secondTitle: 'העברת בעלות תבטל את החבילה המשולבת ואת ההנחות הכרוכות בה, שנמשיך?',
    buttonText: 'כן, בואו נתקדם',
    buttonClick: 'doNextStep',
    nextStep: OwnershipTransferPrivateSellerStep.BuyerDetails,
    secondButtonText: 'לא להמשיך כרגע',
    secondButtonClick: 'closePopup',
    report: '',
  },
};
export const CollapseLabelCheckBox = {
  cellular: {
    defaultText: 'אני מאשר/ת כי ברצוני לבצע העברת בעלות ממני לקונה במספר הטלפון, בכרטיס הסיום ובתכנית החיוב. ',
    get extendedText() {
      return `אני מאשר/ת כי ברצוני לבצע העברת בעלות ממני לקונה במספר הטלפון, בכרטיס הסיום ובתכנית החיוב. בקשה זו מהווה גם בקשה להפסקת שירות כאמור בהסכם התנאים הכלליים להתחברות לרשת ${brandNameHe()}. ידוע לי כי יופסקו כל השירותים שניתנו למספר הטלפון שלהלן. ידוע לי והנני מסכים/ה לכך, כי אין בשינוי המבוקש על ידי בכדי לגרוע מכל האמור בכל הסכם שנחתם ביני לבין ${brandNameHe()}, לרבות ומבלי לגרוע מהסכם התנאים הכלליים והסכם התכנית, ולרבות התחייבותי וחובתי לשלם כל סכום שיגיע ל${brandNameHe()} בגין השימוש במכשיר ובגין רכישת ציוד קצה או מכל סיבה אחרת. ידוע לי והנני מאשר ל${brandNameHe()} למסור לרוכש את סכום חובי ל${brandNameHe()} וכל מידע רלוונטי אחר. העברת הבעלות תושלם לאחר הסכמת הרוכש לבקשה ואישור התהליך על ידי ${brandNameHe()}. העברת הבעלות אינה חלה על חיובים בגין ציוד קצה המחויבים באמצעות החשבונית החודשית או כרטיס אשראי.`;
    },
  },
  stationary: {
    get defaultText() {
      return `אני מאשר/ת כי ברצוני לבצע העברת בעלות ממני לקונה בשירות אינטרנט ו/או ${brandNameHe()} TV, בציוד קצה ובתכנית החיוב. `;
    },
    get extendedText() {
      return `אני מאשר/ת כי ברצוני לבצע העברת בעלות ממני לקונה בשירות אינטרנט ו/או ${brandNameHe()} TV, בציוד קצה ובתכנית החיוב. בקשה זו מהווה גם בקשה להפסקת שירות כאמור בהסכם מנוי תנאים כלליים של ${brandNameHe()} תקשורת קווית ש.מ. ידוע לי כי יופסקו כל השירותים שניתנו למוכר/ת. ידוע לי והנני מסכים לכך, כי אין בשינוי המבוקש על ידי בכדי לגרוע מכל האמור בכל הסכם שנחתם ביני לבין ${brandNameHe()}, לרבות ומבלי לגרוע מהסכם התנאים הכלליים והסכם התכנית, ולרבות התחייבותי וחובתי לשלם כל סכום שיגיע ל${brandNameHe()} בגין השימוש בשירותים או מכל סיבה אחרת. ידוע לי והנני מאשר ל${brandNameHe()} למסור לרוכש/ת את סכום חובי ל${brandNameHe()} וכל מידע רלוונטי אחר. העברת הבעלות תושלם לאחר הסכמת הרוכש/ת לבקשה ואישור התהליך על ידי ${brandNameHe()}. העברת הבעלות אינה חלה על חיובים בגין ציוד קצה המחויבים באמצעות החשבונית החודשית או כרטיס אשראי.`;
    },
  },
};
